export default [
    {
        path: 'dispensacao',
        component: () => import(
            /* webpackChunkName: 'farmacia-dispensacao' */
            '@/views/farmacia/dispensacao/Index'
        ),
        redirect: 'dispensacao/index',
        children: [
            {
                name: 'farmacia-dispensacao-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'farmacia-dispensacao' */
                    '@/views/farmacia/dispensacao/List.vue'
                ),
            },
            {
                name: 'farmacia-dispensacao-create',
                path: 'create/:pacienteId/:filaId?',
                props: route => ({ 
                    pacienteId: parseInt(route.params.pacienteId),
                    filaId: parseInt(route.params.filaId),
                }),
                component: () => import(
                    /* webpackChunkName: 'farmacia-dispensacao' */
                    '@/views/farmacia/dispensacao/Form.vue'
                ),
            },
            {
                name: 'farmacia-dispensacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'farmacia-dispensacao' */
                    '@/views/farmacia/dispensacao/Form.vue'
                ),
            },
        ],
    },
]